import { ButtonDimensions, ValidationSchema } from "lib";

export const schemaButtonDimensions: ValidationSchema<ButtonDimensions> = {
    width: { required: true, number: true, integer: true },
    height: { required: true, number: true, integer: true },
};
